export default function HeroBanner() {
  const scrollTo = (id: string) => {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage:
          "url('https://public.readdy.ai/ai/img_res/fd20e2202f2590497e140af8befd80d2.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/45 to-black/20" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 flex flex-col items-start justify-center pt-20">
        <span className="inline-flex items-center gap-2 bg-teal-500/20 border border-teal-400/40 text-teal-300 text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-6">
          <i className="ri-star-fill text-teal-400" />
          Trusted by 5,000+ Happy Customers
        </span>

        <h1
          className="text-5xl md:text-7xl font-extrabold text-white leading-tight max-w-2xl"
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          Spotless Spaces,
          <br />
          <span className="text-teal-400">Every Time.</span>
        </h1>

        <p className="mt-6 text-lg text-white/75 max-w-xl leading-relaxed">
          Professional residential and commercial cleaning services tailored to your schedule. We bring the shine — you enjoy the space.
        </p>

        {/* Stats Row */}
        <div className="flex items-center gap-8 mt-8 flex-wrap">
          {[
            { value: "5,000+", label: "Homes Cleaned" },
            { value: "12 Yrs", label: "Experience" },
            { value: "4.9★", label: "Avg. Rating" },
          ].map((stat) => (
            <div key={stat.label}>
              <div className="text-2xl font-bold text-white" style={{ fontFamily: "'Poppins', sans-serif" }}>
                {stat.value}
              </div>
              <div className="text-xs text-white/55 uppercase tracking-wide mt-0.5">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* CTAs */}
        <div className="flex items-center gap-4 mt-10 flex-wrap">
          <button
            onClick={() => scrollTo("#booking")}
            className="bg-teal-500 hover:bg-teal-400 text-white font-semibold px-8 py-3.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
          >
            Book a Cleaning
          </button>
          <button
            onClick={() => scrollTo("#services")}
            className="border border-white/50 hover:border-white text-white font-semibold px-8 py-3.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-sm backdrop-blur-sm"
          >
            View Services
          </button>
        </div>

        {/* Quick badges */}
        <div className="flex items-center gap-6 mt-10 flex-wrap">
          {["Insured & Bonded", "Eco-Friendly Products", "Same-Day Available"].map((badge) => (
            <span key={badge} className="flex items-center gap-1.5 text-white/70 text-xs">
              <i className="ri-checkbox-circle-fill text-teal-400 text-sm" />
              {badge}
            </span>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 animate-bounce">
        <span className="text-white/40 text-xs">Scroll</span>
        <i className="ri-arrow-down-line text-white/40" />
      </div>
    </section>
  );
}
